﻿import { differenceInYears } from 'date-fns';
/**
 * Calculates whether the patient meets the minimum age requirement for facility.
 * @param {string | Date | null} params.patientDob - The date of birth of the patient.
 * @param {number} params.facilityMinimalAge - Number that represents the minimum age requirement for facility.
 * @returns {boolean} true if the patient minimum age is lower than facility minimum age, false otherwise.
 */
export function isPatientUnderage(patientDob: string | Date | null, facilityMinimalAge: number | null | undefined) {
	if (patientDob) {
		const birthDate = new Date(patientDob);
		// datepicker selected date will have some hh:mm:ss values set so we have to reset
		// them in order for cover the case when someone is born on this day and it passes facilityMinimalAge check
		birthDate.setHours(0, 0, 0, 0);
		const patientAge = differenceInYears(new Date(), birthDate);

		if (Number.isFinite(patientAge) && Number.isFinite(facilityMinimalAge)) {
			return facilityMinimalAge! > patientAge;
		}
	}

	// always proceed in case of an error or bad data
	return false;
}
